import { NextPage } from 'next'
import Layout from '@layouts/Text'
import { TextBlock } from '@components/content'
import PageHeader from '@components/PageHeader'
import Link from '@components/Link'
import { H5 } from '@components/Heading'

const SEOSEMSpecialist: NextPage = () => (
  <>
    <PageHeader title={[['SEO/SEM', 'Specialist']]} />

    <Layout>
      <TextBlock className="mb-80">
        <p>
          W związku z rozwojem naszej Agencji Interaktywnej szukamy ambitnego i
          zdolnego specjalisty ds. SEO/SEM, chcącego dołączyć do naszego
          zespołu.
        </p>

        <H5>Wymagania</H5>

        <ul>
          <li>umiejętność optymalizacji stron www</li>
          <li>umiejętność skutecznego link buildingu</li>
          <li>doświadczenie w pozycjonowaniu stron www</li>
          <li>
            Znajomość narzędzi służących do analiz stron www pod kątem SEO
            (Ahrefs, Majestic SEO)
          </li>
          <li>Podstawowa znajomość HTML/CSS</li>
        </ul>

        <H5>Mile widziane:</H5>

        <ul>
          <li>znajomość systemów CMS (Joomla, Wordpress)</li>
          <li>
            doświadczenie w realizacji kampanii reklamowych Google Adwords
          </li>
          <li>
            doświadczenie w realizacji kampanii reklamowych na portalu Facebook
          </li>
        </ul>

        <H5>Oferujemy?</H5>

        <ul>
          <li>Pracę na pełen etat</li>
          <li>Przyjazną i niekorporacyjną atmosferę</li>
          <li>Pracę w klimatyzowanym biurze</li>
          <li>Możliwość rozwoju przy ambitnych projektach</li>
          <li>
            Własne stanowisko pracy (2 duże monitory, pełen zestaw narzędzi
            niezbędnych do pozycjonowania stron www)
          </li>
          <li>Stół z piłkarzykami ;)</li>
          <li>Wynagrodzenie uzależnione od umiejętności</li>
          <li>Pakiet multisport i pakiet medyczny</li>
        </ul>
      </TextBlock>

      <TextBlock>
        <p>
          Prosimy o zamieszczenie następującej klauzuli w Państwa dokumentach:
        </p>
        <p>
          <em>
            Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych
            zawartych w dokumentach rekrutacyjnych dla celów naboru (zgodnie z
            ustawą o ochronie danych osobowych z 29 sierpnia 1997 r., Dz. U. nr
            133, poz. 883).
          </em>
        </p>

        <p>
          CV prosimy wysyłać na{' '}
          <Link href="mailto:hello@empressia.co">hello@empressia.co</Link>
        </p>
      </TextBlock>
    </Layout>
  </>
)

export default SEOSEMSpecialist
